import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

/* ──────────────────────── data ──────────────────────── */

interface DocumentItem {
  title: string;
  category: string;
  href: string;
  isExternal?: boolean;
}

interface DocCategory {
  id: string;
  title: string;
  icon: string;
  externalHref: string;
  docs: DocumentItem[];
}

const categoryData: DocCategory[] = [
  {
    id: "annual-reports",
    title: "Annual Reports",
    icon: "ri-file-chart-line",
    externalHref: "https://www.mpfcanada.ca/resources/annual-reports/",
    docs: [
      { title: "2025 Annual Report", category: "Annual Report", href: "/wp-content/2026/MPFCanada_AR_2025_EN%20FINAL-s.pdf" },
      { title: "2024 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2025/07/MPF_AR_2024_ENG-FINAL-s.pdf" },
      { title: "2023 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2024/07/MPF_AR_2023_ENG-Final_FINAL-s.pdf" },
      { title: "2022 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2023/06/MPF_AR_2022_ENG_FINAL-s.pdf" },
      { title: "2021 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2022/06/MPF_AR_2021_ENG_FINAL-s.pdf" },
      { title: "2020 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2021/06/MPF_AR_2020_ENG.pdf" },
      { title: "2019 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2020/06/MPF_AR2019_ENG-Final_s.pdf" },
      { title: "2018 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2019/07/MPF_AR2018_ENG" },
      { title: "2017 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2018/07/2017_MPFC_AR_FINAL-s.pdf" },
      { title: "2016 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2017/07/2016_MPFC_AR%20FINAL-s.pdf" },
      { title: "2015 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2016/07/2015_MPFC-Fund-Annual-Report-FINAL-s.pdf" },
      { title: "2014 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2015/15/MPF-AnnualReport2014_AODA.pdf" },
      { title: "2013 Annual Report", category: "Annual Report", href: "/wp-content/uploads/2015/15/MPF_AR_2013-AODA.pdf" },
    ],
  },
  {
    id: "newsletters",
    title: "Newsletters",
    icon: "ri-mail-line",
    externalHref: "https://www.mpfcanada.ca/resources/newsletters/",
    docs: [
      { title: "OCTOBER 2026 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2026-10-web/english.html" },
      { title: "JULY 2026 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2026-07-web/english.html" },
      { title: "APRIL 2026 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202604/english.html" },
      { title: "DECEMBER 2025 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202512/english.html" },
      { title: "SEPTEMBER 2025 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202509/english.html" },
      { title: "JULY 2025 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202507/english.html" },
      { title: "MARCH 2025 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202504/english.html" },
      { title: "DECEMBER 2024 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202412/english.html" },
      { title: "JULY 2024 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202407/english.html" },
      { title: "MARCH 2024 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202403/english.html" },
      { title: "DECEMBER 2023 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202312/english.html" },
      { title: "SEPTEMBER 2023 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202309/english.html" },
      { title: "JULY 2023 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202307/english.html" },
      { title: "MARCH 2023 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202303/english.html" },
      { title: "DECEMBER 2022 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202212/english.html" },
      { title: "OCTOBER 2022 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202210/english.html" },
      { title: "JULY 2022 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202207/english.html" },
      { title: "MARCH 2022 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202203/english.html" },
      { title: "DECEMBER 2021 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202112/english.html" },
      { title: "NOVEMBER 2021 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202111/english.html" },
      { title: "JUNE 2021 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202106/english.html" },
      { title: "MARCH 2021 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202103/english.html" },
      { title: "DECEMBER 2020 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202012/english.html" },
      { title: "OCTOBER 2020 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202010/english.html" },
      { title: "JUNE 2020 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-202006/english.html" },
      { title: "DECEMBER 2019 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201912/english.html" },
      { title: "SEPTEMBER 2019 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201909/english.html" },
      { title: "JUNE 2019 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201906/english.html" },
      { title: "MARCH 2019 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201903/english.html" },
      { title: "DECEMBER 2018 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201901/english.html" },
      { title: "OCTOBER 2018 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201810/english.html" },
      { title: "August 2018 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201808/english.html" },
      { title: "April 2018 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201804/english.html" },
      { title: "December 2017 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201712/english.html" },
      { title: "November 2017 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201711/english.html" },
      { title: "August 2017 Newsletter", category: "Newsletter", href: "/wp-content/uploads/nl-201708/english.html" },
      { title: "April 2017 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2017/04/MPF-April-2017-English-Newsletter.pdf" },
      { title: "December 2016 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2016/12/MPF-DECEMBER-2016-English-Newsletter.pdf" },
      { title: "October 2016 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2016/11/MPF-OCTOBER-2016-English-Newsletter.pdf" },
      { title: "July 2016 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2016/07/MPF-JULY-2016-English-Newsletter.pdf" },
      { title: "April 2016 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2016/05/MPF-2016-Newsletter.pdf" },
      { title: "July 2014 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/inconcert-July2014-AODA.pdf" },
      { title: "June 2013 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/InConcert-Jun2013.pdf" },
      { title: "Fall 2012 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/InConcert-50thAnniversary.pdf" },
      { title: "February 2012 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/InConcert-Feb2012-English.pdf" },
      { title: "Fall 2010 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/InConcert-Fall-2010.pdf" },
      { title: "Fall 2009 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/InConcert-Fall-2009-English.pdf" },
      { title: "Winter 2008 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2016/03/Winter-2008-09-Newsletter.pdf" },
      { title: "September 2007 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/AFM-EPW%20Newsletter~E5%20Aug.pdf" },
      { title: "Fall 2004 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/AFM%20NewsENG%20N4.%20fall%202004%20Finalpdf.pdf" },
      { title: "December 2003 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/December%202003%20English.pdf" },
      { title: "Fall 2003 Newsletter", category: "Newsletter", href: "/wp-content/uploads/2015/15/AFM_NewsENG_N7381.pdf" },
    ],
  },
  {
    id: "forms",
    title: "Forms",
    icon: "ri-file-download-line",
    externalHref: "https://www.mpfcanada.ca/resources/forms/",
    docs: [
      { title: "Member Information – Change Of Beneficiary", category: "Forms", href: "/wp-content/uploads/2015/15/Member%20Info%20Change%20of%20Beneficiary.pdf" },
      { title: "Change Of Address Notice", category: "Forms", href: "/wp-content/uploads/2015/15/Change%20of%20Address.pdf" },
      { title: "Request For Pension Application", category: "Forms", href: "/wp-content/uploads/2015/15/Request%20for%20Pension%20Application.pdf" },
    ],
  },
  {
    id: "what-happens-if",
    title: "What Happens If?",
    icon: "ri-question-line",
    externalHref: "https://www.mpfcanada.ca/resources/what-happens-if/",
    docs: [
      { title: "I Apply for My Pension After I Turn 71 Years Old?", category: "What Happens If?", href: "/wp-content/uploads/2023/10/WhatHappensifPensionafterage71_EN%20FINAL-s.pdf" },
      { title: "I Want to Change My Beneficiary?", category: "What Happens If?", href: "/wp-content/uploads/2022/08/What_Happens_If_I_Change_my_Beneficiary_En_FINAL.pdf" },
      { title: "I die before/after I begin receiving my pension benefit?", category: "What Happens If?", href: "/wp-content/uploads/2020/07/MPFC_What_Happens_If_I_Die_Before_Receiving_My_Pension_FINAL-s.pdf" },
      { title: "I Become Disabled?", category: "What Happens If?", href: "/wp-content/uploads/2018/11/MPF_WhatHappensIf-Disabled_ENG_FINAL-s.pdf" },
      { title: "I get divorced?", category: "What Happens If?", href: "/wp-content/uploads/2017/07/MPF_WhatHappensif_Divorced.pdf" },
      { title: "I leave the music business (and if I return)", category: "What Happens If?", href: "/wp-content/uploads/2017/07/WhathappensIfIleaveMusicBus%20FINAL-s.pdf" },
      { title: "I Work in the U.S.?", category: "What Happens If?", href: "/wp-content/uploads/2018/06/English_MPF_WhatHappensIf-Work_in_the_US_FINAL-s.pdf" },
      { title: "I Continue to Work (or Return to Work) While I\u2019m Receiving My Pension Benefit?", category: "What Happens If?", href: "/wp-content/uploads/2022/02/MPFC_What_Happens_If_I_Continue_Working_after_My_Pension_Starts_FINAL-s.pdf" },
      { title: "I apply for an Early pension?", category: "What Happens If?", href: "/wp-content/uploads/2021/09/MPF_WhatHappensIf-RetireEarly_En_FINAL-s.pdf" },
    ],
  },
  {
    id: "things-you-need-to-know",
    title: "Things You Need to Know",
    icon: "ri-lightbulb-line",
    externalHref: "https://www.mpfcanada.ca/resources/things-you-need-to-know/",
    docs: [
      { title: "I want to file a complaint with the Musicians’ Pension Fund of Canada (MPFC)?", category: "Things You Need to Know", href: "/wp-content/uploads/2025/09/Things-You-Need-to-Know-Appeals_ENG_FINAL-s.pdf" },
      { title: "Don’t Let Inflation Give Your Retirement the Blues", category: "Things You Need to Know", href: "/wp-content/uploads/2022/07/Things_You_Need_to_Know-Inflation_EN_FINAL-s.pdf" },
      { title: "Keeping Your Contact Information Up to Date with the Fund Office", category: "Things You Need to Know", href: "/wp-content/uploads/2020/08/MPFC_2020_Things_You_Need_To_Know_Contact_Info_FINAL.pdf" },
      { title: "Contract Requirements for Leaders", category: "Things You Need to Know", href: "/wp-content/uploads/2022/02/MPF_ThingstoKnow-ContractRequirements_ENG_FINAL-s.pdf" },
      { title: "What is “Vesting”?", category: "Things You Need to Know", href: "/wp-content/uploads/2017/07/MPF_What%20is%20Vesting.pdf" },
      { title: "What the Fund’s Trustees Do", category: "Things You Need to Know", href: "/wp-content/uploads/2017/11/MPF_Things_You_need_to_know_FINAL.pdf" },
      { title: "Contributions", category: "Things You Need to Know", href: "/wp-content/uploads/2018/10/Things_You_Need_to_Know-Contributions_FINAL-s.pdf" },
      { title: "About Applying for a Pension Benefit", category: "Things You Need to Know", href: "/wp-content/uploads/2019/08/MPFC_Things_You_Need_to_Know_About_Applying_for_Your_Pension_FINAL-s.pdf" },
      { title: "Trustees Amend Plan to Help During COVID-19", category: "Things You Need to Know", href: "/wp-content/uploads/2021/10/2021-Things_You_Need_To_Know_COVID-19_FINAL-s.pdf" },
      { title: "Ineligible Pension Contributions", category: "Things You Need to Know", href: "/wp-content/uploads/2023/06/Things-You-Need-to-Know-Ineligible-Contributions-02-FINAL-s.pdf" },
    ],
  },
  {
    id: "miscellaneous",
    title: "Miscellaneous",
    icon: "ri-folder-line",
    externalHref: "https://www.mpfcanada.ca/resources/miscellaneous/",
    docs: [
      { title: "Privacy Policy (Effective January 1, 2004)", category: "Miscellaneous", href: "/wp-content/uploads/2026/privacy.html" },
      { title: "General Brochure", category: "Miscellaneous", href: "/wp-content/uploads/2021/03/2021_MPFCanada_Brochure-English_FINAL-s.pdf" },
    ],
  },
  {
    id: "links",
    title: "Links",
    icon: "ri-link",
    externalHref: "https://www.mpfcanada.ca/resources/links/",
    docs: [
      { title: "Canadian Federation of Musicians", category: "Links", href: "http://www.cfmusicians.org/", isExternal: true },
      { title: "Services Canada", category: "Links", href: "http://www.servicecanada.gc.ca/eng/home.shtml", isExternal: true },
    ],
  },
  {
    id: "rrsp-comparisons",
    title: "RRSP Comparisons",
    icon: "ri-scales-line",
    externalHref: "https://www.mpfcanada.ca/resources/rrsp-comparisons/",
    docs: [
      { title: "RRSP comparisons", category: "RRSP Comparisons", href: "/wp-content/uploads/2019/08/Comparison-MPFC-vs-RRSP-English.pdf" },
    ],
  },
  {
    id: "somepp-notice",
    title: "SOMEPP Notice",
    icon: "ri-file-warning-line",
    externalHref: "https://www.mpfcanada.ca/resources/somepp-notice/",
    docs: [
      { title: "SOMEPP Notice", category: "SOMEPP Notice", href: "/wp-content/uploads/2025/11/MPFC%20SOMEPP%20Notice%202025%20English.html" },
    ],
  },
  {
    id: "key-plan-definitions",
    title: "Key Plan Definitions",
    icon: "ri-book-open-line",
    externalHref: "https://www.mpfcanada.ca/resources/understanding-key-plan-definitions/",
    docs: [
      { title: "Understanding Key Plan Definitions", category: "Key Plan Definitions", href: "/wp-content/uploads/2020/10/MPFC_Definitions_FINAL.pdf" },
      { title: "Glossary of Terms", category: "Key Plan Definitions", href: "/wp-content/themes/mpfcanada/pdf/download_attachment.pdf" },
    ],
  },
];

/* ──────────────────────── sub-components ──────────────────────── */

function DocumentRow({ doc }: { doc: DocumentItem }) {
  return (
    <a
      href={doc.href}
      target="_blank"
      rel={doc.isExternal ? "nofollow" : "noopener noreferrer"}
      className="flex items-center justify-between gap-3 py-3 px-3 rounded-md border-b border-gray-100/70 last:border-b-0 hover:bg-[#e1edf5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1a8fc1]/40 focus-visible:ring-offset-0 transition-colors duration-200 cursor-pointer group"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded bg-[#0d1f4c]/6">
          {doc.isExternal ? (
            <i className="ri-external-link-line text-xs text-[#0d1f4c]"></i>
          ) : (
            <i className="ri-file-pdf-2-line text-xs text-[#0d1f4c]"></i>
          )}
        </div>
        <h4 className="text-sm font-medium text-[#0d1f4c] truncate">
          {doc.title}
        </h4>
      </div>
      <span className="flex-shrink-0 flex items-center gap-1.5 text-xs font-medium text-[#1a8fc1] border border-[#1a8fc1]/30 bg-white group-hover:bg-[#e8f4fa] group-hover:border-[#1a8fc1]/60 group-hover:text-[#0d6e9e] px-2.5 py-1 rounded-md transition-all duration-200 whitespace-nowrap pointer-events-none">
        {doc.isExternal ? "Open" : "View"}
        <i className={`${doc.isExternal ? "ri-external-link-line" : "ri-arrow-right-line"} text-xs`}></i>
      </span>
    </a>
  );
}

/* ──────────────────────── page ──────────────────────── */

export default function Resources() {
  const location = useLocation();
  const navigate = useNavigate();

  const getCategoryFromUrl = (): string => {
    // First check query params (?category=xxx)
    const params = new URLSearchParams(location.search);
    const cat = params.get("category");
    if (cat && categoryData.some((c) => c.id === cat)) {
      return cat;
    }
    // Fallback: check hash (#xxx) — used by header Resources dropdown
    const hash = location.hash.replace("#", "");
    if (hash && categoryData.some((c) => c.id === hash)) {
      return hash;
    }
    return "annual-reports";
  };

  const [activeId, setActiveId] = useState(getCategoryFromUrl);
  const [contentKey, setContentKey] = useState(0);

  useEffect(() => {
    const newId = getCategoryFromUrl();
    setActiveId(newId);
  }, [location.search, location.hash]);

  // Scroll to top when arriving from another page — query params don't
  // trigger browser hash scrolling, but ensure we always land at the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // only on mount

  const handleCategorySelect = (id: string) => {
    if (id === activeId) return;
    setActiveId(id);
    setContentKey((prev) => prev + 1);
    navigate({ search: `?category=${id}` }, { replace: true });
  };

  const activeCategory = categoryData.find((c) => c.id === activeId) ?? categoryData[0];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />

      <main className="flex-1">
        {/* ── hero / page header ── */}
        <section className="w-full bg-[#0d1f4c] py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#7ec8e3] text-xs font-semibold tracking-widest uppercase">
                Member Resources
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Resources &amp; Documents
            </h1>
            <p className="text-base text-white/70 max-w-[560px]">
              Access plan documents, forms, reports, and reference materials for the Musicians&apos; Pension Fund of Canada.
            </p>
          </div>
        </section>

        {/* ── mobile category dropdown ── */}
        <div className="lg:hidden w-full bg-[#f4f8fc] border-b border-gray-100 py-4">
          <div className="max-w-[1200px] mx-auto px-6">
            <label htmlFor="cat-select" className="sr-only">Select Resource Category</label>
            <select
              id="cat-select"
              value={activeId}
              onChange={(e) => handleCategorySelect(e.target.value)}
              className="w-full text-sm font-medium text-[#0d1f4c] bg-white border border-gray-200 rounded-lg px-4 py-3 appearance-none cursor-pointer focus:outline-none focus:border-[#1a8fc1] focus:ring-2 focus:ring-[#1a8fc1]/20"
              style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230d1f4c' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                paddingRight: "40px",
              }}
            >
              {categoryData.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* ── two-column body ── */}
        <div className="w-full bg-white">
          <div className="max-w-[1200px] mx-auto px-6 flex flex-col lg:flex-row gap-0">
            {/* left sidebar — desktop only */}
            <aside className="hidden lg:block w-[260px] flex-shrink-0 border-r border-gray-100 py-8 pr-6">
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-4">
                Categories
              </h3>
              <nav className="space-y-0.5">
                {categoryData.map((cat) => {
                  const isActive = cat.id === activeId;
                  return (
                    <button
                      key={cat.id}
                      onClick={() => handleCategorySelect(cat.id)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-left text-sm transition-all duration-200 cursor-pointer whitespace-nowrap ${
                        isActive
                          ? "bg-[#e8f2f9] text-[#0d1f4c] font-semibold border-l-2 border-[#1a8fc1]"
                          : "text-gray-600 hover:bg-[#f4f8fb] hover:text-[#0d1f4c] font-normal border-l-2 border-transparent"
                      }`}
                    >
                      <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ${isActive ? "text-[#1a8fc1]" : "text-gray-400"}`}>
                        <i className={`${cat.icon} text-sm`}></i>
                      </span>
                      <span className="truncate">{cat.title}</span>
                      {isActive && (
                        <span className="ml-auto w-1.5 h-4 rounded-full bg-[#1a8fc1] flex-shrink-0"></span>
                      )}
                    </button>
                  );
                })}
              </nav>
            </aside>

            {/* right content area */}
            <div id="resources-content" className="flex-1 min-w-0 py-8 lg:pl-8 scroll-mt-14" key={contentKey}>
              {/* section header */}
              <div className="mb-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-5 h-0.5 bg-[#1a8fc1]"></div>
                  <h2 className="text-lg font-bold text-[#0d1f4c]">
                    {activeCategory.title}
                  </h2>
                </div>
                <p className="text-sm text-gray-500">
                  {activeCategory.docs.length} document{activeCategory.docs.length !== 1 ? "s" : ""}
                </p>
              </div>

              {/* document list panel */}
              <div className="bg-[#fafbfd] rounded-lg border border-gray-100 p-5 animate-content-switch">
                {activeCategory.docs.map((doc) => (
                  <DocumentRow key={doc.title} doc={doc} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}